<template>
  <div>
    <h2>第三方 SDK 清单</h2>

    <p>以下是卡普喔使用的第三方 SDK 的情况，我们将不时地更新此清单，以更清晰地展示卡普喔与第三方合作或使用第三方功能以完善卡普喔产品和服务体验的情况。我们会对 SDK 的接入和使用进行符合互联网行业通常能力的审核，以保障你的个人信息安全。也请你理解，即便我们尽可能地及时更新此清单，但在一定情况下仍可能会滞后于卡普喔实际使用的情况。同时，为了对卡普喔的商业信息和技术手段保密，部分用于平台风控或特殊合作的 SDK 可能不在此清单中，但该等 SDK 如需获取你的重要隐私信息或设备权限时，我们会通过合理方式取得你的授权同意。</p>

    <p>SDK 全称 Software Development Kit ，通常翻译为软件开发工具包。是指用于为特定的软件包、软件框架、硬件平台、操作系统等创建应用软件的开发工具的集合。</p>

    <p>请注意，第三方 SDK 可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，具体请以其公示的官方说明为准。</p>
    <table border="1" class="tab">
      <thead>
      <tr>
        <th>SDK 名称</th>
        <th>使用目的</th>
        <th>收集数据类型</th>
        <th>隐私政策/官网链接</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(ele,index) in info">
        <td>{{ele.name}}</td>
        <td>{{ele.goal}}</td>
        <td>{{ele.type}}</td>
        <td class="link"><a :href="ele.link">{{ele.link}}</a></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'List',
  data () {
    return {
      info:[
        {name:"微信开放平台 SDK",goal:"支持微信授权登录、微信分享、微信支付",type:"设备标识信息",link:"https://open.weixin.qq.com/"},
        {name:"QQ 登录 SDK",goal:"支持QQ授权登录、QQ分享",type:"设备标识信息",link:"https://wiki.connect.qq.com/oauth2-0简介"},
        {name:"Alipay（支付宝） SDK",goal:"支持使用支付宝支付",type:"设备标识信息、地理位置、网络信息",link:"https://docs.open.alipay.com/54"},
        {name:"穿山甲(com.bytedance.embedapplog)",goal:"广告投放",type:"硬件型号、操作系统版本号、IP 地址、WLAN 接入点、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志",link:"https://www.oceanengine.com/resource/chuanshanjia"},
        {name:"广点通 SDK",goal:"广告投放",type:"设备标识信息、地理位置",link:"https://e.qq.com/ads/"},
        {name:"阿里 OSS 上传",goal:"图片上传",type:"设备标识信息、IP 地址、位置信息",link:"https://www.aliyun.com/product/oss"},
        {name:"友盟+(com.umeng.commonsdk)",goal:"统计分析服务、基础反作弊服务",type:"设备Mac地址、唯一设备识别码（MAC/IMEI/android ID/OPENUDID/GUID/SIM卡IMSI信息）、用于反作弊的地理位置信息",link:"https://www.umeng.com/policy"},
        {name:"友盟分享",goal:"分享服务",type:"设备Mac地址、唯一设备识别码（MAC/IMEI/android ID/OPENUDID/GUID/SIM卡IMSI信息）、IP地址、地理位置信息",link:"https://www.umeng.com/policy"},
        {name:"百度联盟",goal:"广告投放",type:"基于用户授权获取：设备及应用信息、移动网络信息、位置信息",link:"https://union.baidu.com/bqt/#/policies"},
      ]

  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

body {
  margin: 16px;
  font-size: 12px
}

h1 {
  font-size: 24px;
  margin: 20px 0;
}

h2 {
  margin: 20px 0;
  font-size: 20px
}

h3 {
  margin: 20px 0;
  font-size: 20px
}

li {
  padding: 4px 0;
  list-style: none;
}


p {
  margin: 20px 0;
}
.tab{
  table-layout: fixed;
  text-align: left;
  width:100%;
  border-collapse:collapse;
}
.tab tr{
width:100%;
}
.tab th{
  padding:0 4px;
}
.tab td{
  width:25%;
  padding:0 4px;
  word-break:break-all;
}
.link{
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue